
<div class="redirect-page-wrapper">
    <div class="redirect-page-inner">
        <div class="redirect-page-logo">
            <img src="assets/demo/images/champ.png" alt="Sakai logo" class="mb-4 w-6rem flex-shrink-0" />
        </div>
        <div class="redirect-page-content">
            <div class="redirect-content-title">
                <i class="pi pi-credit-card redirect-title-icon"></i>
                <span class="redirect-title-text">Payment Information</span>
            </div>
            <div class="divider"></div>
            <div class="detail-section">
                <span class="title">Reference&nbsp;:&nbsp;</span>
                <span class="value">{{dataString["transactionReference"]}}</span>
            </div>
            <div class="detail-section">
                <span class="title">Currency&nbsp;:&nbsp;</span>
                <span class="value">{{dataString["currencyCode"]}}</span>
            </div>
            <div class="detail-section">
                <span class="title">Amount&nbsp;:&nbsp;</span>
                <span class="value">{{dataString["amount"] | currency:dataString["currencyCode"]}}</span>
            </div>
        </div>
        <div class="redirect-page-content">
            <div class="divider"></div>
            <form action="payment-success?currencyCode={{dataString['currencyCode']}}" class="paymentWidgets" data-brands="PRIVATE_LABEL"></form>
        </div>
    </div>
</div>
